import React from "react";
import PropTypes from "prop-types";

const ProgressBar = ({ completed, bgColor, customLabel }) => {
  const progressStyle = {
    width: `${completed}%`,
    backgroundColor: bgColor,
  };

  return (
    <div className="progress-bar-container">
      <div className="progress-bar" style={progressStyle}></div>
      <span className="progress-label">{customLabel}</span>
    </div>
  );
};

ProgressBar.propTypes = {
  completed: PropTypes.number.isRequired,
  bgColor: PropTypes.string.isRequired,
  customLabel: PropTypes.string.isRequired,
};

export default ProgressBar;
